module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JchlHI/images/cover.jpg?1733085643025",
      "alt": "This image is the cover for the book Fearless"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fearless\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Rafael Yglesias’s novel of trauma, loss, and the bonds formed between victims of catastrophe.")])]), _vm._v("Max Klein suffers from many anxieties—including a terrible fear of flying—but after surviving a plane crash his worries vanish and he suddenly believes himself invincible. Back home, a psychiatrist puts him in touch with Carla, a victim of the same crash who lost her infant son and suffers from a morbid, debilitating depression. Now Max and Carla begin a relationship that is sometimes intimate, sometimes painful, and perhaps the only path to recovery for both. "), _c('i', [_vm._v("Fearless")]), _vm._v(" is a brilliant portrait of trauma and its aftermath—the shock of loss and the sometimes unexpected ways that people learn to cope with disaster. "), _c('i', [_vm._v("This ebook features a new illustrated biography of Rafael Yglesias, including rare photos and never-before-seen documents from the author’s personal collection.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rafael Yglesias\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v(" ")]), _vm._v("Rafael Yglesias (b. 1954) is a master American storyteller whose career began with the publication of his first novel, "), _c('i', [_vm._v("Hide Fox, and All After")]), _vm._v(", at seventeen. Through four decades Yglesias has produced numerous highly acclaimed novels, including "), _c('i', [_vm._v("Fearless")]), _vm._v(", which was adapted into the film starring Jeff Bridges and Rosie Perez. He lives on New York City’s Upper East Side."), _c('p', [_vm._v(" ")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0